import React, { useState, useEffect } from "react";
import "./org.css";
import TopContent from "./top.content";
import MainContent from "./main.content";
window.$first_load = true;

const Org = (props) => {
  let userData = window.$user_profile;
  const defaultFilters = {
    organization: userData.user_org,
    //organization: [10],
    //organization: [71, 72, 74],
    //organization: [3, 10, 2],
    //organization: userData.user_org,
    //department: [10001],
    //name: ["nat"],
    limit: 5,
    page: 1,
    key_form: 0 };
  const [clearFilters, setClearFilters] = useState(0);
  const [showFullnameAndPosition, setShowFullnameAndPosition] = useState(false);

  const handleEvents = {
    SelectShowFullNameAndPosition: {
      OnChange: function (evt) {
        const { checked } = evt.target;
        setShowFullnameAndPosition(checked);
      } } };

  useEffect(() => {
    const container = document.getElementById("container");
    if (container) {
      container.style.maxWidth = "none";
    }
  }, []);

  return (
    <div id="org-content" className="inner-container">
      <TopContent
        defaultFilters={defaultFilters}
        key_form={clearFilters}
        showFullnameAndPosition={showFullnameAndPosition}
        handleEvents={handleEvents}
      />
      <MainContent
        userData={userData}
        defaultFilters={defaultFilters}
        setClearFilters={setClearFilters}
        showFullnameAndPosition={showFullnameAndPosition}
      />
    </div>
  );
};
export default Org;

